import { Module } from 'vuex';
import { QuerySignalsState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { QUERY_SIGNALS_ACTIONS } from './query-signals.actions';
import { QUERY_SIGNALS_GETTERS } from './query-signals.getters';
import { QUERY_SIGNALS_MUTATIONS } from './query-signals.mutations';
import { getInitialQuerySignalsState } from './query-signals.state';

export const QUERY_SIGNALS_MODULE: Module<QuerySignalsState, RootStoreState> = {
  namespaced: true,
  actions: QUERY_SIGNALS_ACTIONS,
  mutations: QUERY_SIGNALS_MUTATIONS,
  getters: QUERY_SIGNALS_GETTERS,
  state: getInitialQuerySignalsState()
};
